<app-page-layout
  [pageTitle]="'Audit Logs'"
  [subtitle]="'Group, membership, scope and authentication events.'">

  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center gap-3">
      <div class="relative w-72">
        <p-iconField iconPosition="left" class="w-72">
          <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
          <input
            type="text"
            pInputText
            placeholder="Search audit logs..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
            class="w-full"
          />
        </p-iconField>
      </div>

      <div class="relative w-56">
        <p-select
          [(ngModel)]="groupFilter"
          [options]="groupOptions"
          optionLabel="label"
          appendTo="body"
          optionValue="value"
          (ngModelChange)="setGroupFilter($event)"
          class="w-full"
          placeholder="Filter Groups"
          [showClear]="true">
        </p-select>
      </div>

      <div class="relative w-48">
        <p-select
          [(ngModel)]="resultFilter"
          [options]="resultOptions"
          optionLabel="label"
          optionValue="value"
          (ngModelChange)="setResultFilter($event)"
          class="w-full"
          placeholder="Filter Results"
          [showClear]="true">
        </p-select>
      </div>
    </div>
  </div>

  <!-- State Container -->
  <app-state-container
    [state]="viewState()"
    loadingMessage="Loading audit logs..."
    loadingSubMessage="Please wait while we fetch your audit logs"
    emptyIcon="pi-history"
    emptyTitle="No audit logs found"
    [emptyMessage]="emptyStateMessage()"
    [showEmptyAction]="false"
    [showClearFilters]="showClearFilters()"
    [errorMessage]="errorMessage()"
    (clearFilters)="clearFilters()"
    (retry)="retryLoad()"
  >
    <div class="bg-white dark:bg-zinc-950 rounded-lg border border-surface-200 dark:border-zinc-800">
      <p-table
        [value]="visibleLogs()"
        [loading]="loading()"
        class="p-datatable-sm"
        [resizableColumns]="true"
        columnResizeMode="fit"
        [rowHover]="true">

        <ng-template pTemplate="header">
          <tr class="bg-surface-100 dark:bg-zinc-900 text-surface-600">
            <th pResizableColumn style="min-width: 180px" class="bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              <span>Time</span>
            </th>
            <th pResizableColumn style="min-width: 200px" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              <span>Event</span>
            </th>
            <th pResizableColumn style="min-width: 180px" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              <span>Actor</span>
            </th>
            <th pResizableColumn style="min-width: 220px" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              <span>Resource</span>
            </th>
            <th pResizableColumn style="min-width: 120px" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              <span>Result</span>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-log>
          <tr class="border-t border-surface-200 dark:border-surface-700 hover:bg-surface-50 dark:hover:bg-surface-800 transition">
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">{{ log.createdAt | date: 'dd MMM yyyy, hh:mm a' }}</td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">{{ log.event }}</td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">{{ log.actor }}</td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">{{ log.resource || '--' }}</td>
            <td class="px-4 py-2">
              <span
                class="px-2 py-0.5 rounded text-xs font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300': log.result === 'SUCCESS',
                  'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300': log.result === 'FAILED',
                  'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300': log.result === 'ERROR'
                }">
                {{ log.result }}
              </span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-6 text-surface-500 dark:text-surface-400">
              No audit logs found
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords()"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        (onPageChange)="onPageChange($event)"
        class="mt-0">
      </p-paginator>
    </div>
  </app-state-container>
</app-page-layout>